import { __assign } from "tslib";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getRowConfig, getIsRowOverlayOn, } from '../../../selectors/layoutOverlay';
import Rows from '../../../components/handoff/layout/Rows';
import onlyIf from '../../../hocs/onlyIf';
function mapStateToProps(state) {
    return __assign(__assign({}, getRowConfig(state)), { isOverlayOn: getIsRowOverlayOn(state) });
}
var isOverlayOn = function (props) { return props.isOverlayOn; };
export default compose(connect(mapStateToProps), onlyIf(isOverlayOn))(Rows);
